import script from "./Wrap.vue?vue&type=script&setup=true&lang=js"
export * from "./Wrap.vue?vue&type=script&setup=true&lang=js"

import "./Wrap.vue?vue&type=style&index=0&id=2a257a11&lang=scss"

const __exports__ = script;

export default __exports__